// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"b98a211c","206":"9ff1d1d6","395":"4864cac1","592":"326951cd","787":"32bf64e7"}[chunkId] + ".chunk.js";
};